import { Divider } from "antd";

import { useQuery } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { getAllLocations } from "../../../network/location";
import { queryKeys } from "../../../services/react-query/queryKeys";
import SwitchItem from "../../common/SwitchItem";

const GeneralAlerts = ({ data }: any) => {
  const intl = useIntl();
  const {
    data: locations,
    isError,
    isLoading,
  } = useQuery([queryKeys.Locations], getAllLocations);
  const options = [
    {
      value: "1",
      label: (
        <span className="text-sm font-semibold text-color-primary ">
          1 {intl.formatMessage({ id: "hour" })}
        </span>
      ),
    },
    {
      value: "6",
      label: (
        <span className="text-sm font-semibold text-color-primary ">
          6 {intl.formatMessage({ id: "hour" })}
        </span>
      ),
    },
    {
      value: "12",
      label: (
        <span className="text-sm font-semibold text-color-primary ">
          12 {intl.formatMessage({ id: "hour" })}
        </span>
      ),
    },
    {
      value: "24",
      label: (
        <span className="text-sm font-semibold text-color-primary">
          24 {intl.formatMessage({ id: "hour" })}
        </span>
      ),
    },
  ];

  return (
    <>
      <div className={`bg-[#EEF0FF] rounded-b-lg p-6`}>
        <div className="w-full p-4 bg-white rounded-lg">
          <div className="flex flex-col justify-between">
            <span className="text-color-primary text-sm mb-4 bg-[#EEF0FF] w-fit p-1 rounded">
              {intl.formatMessage({ id: "customerAlerts" })}
            </span>
            <div className="flex items-center gap-2">
              <span className="text-[#75757E] text-sm font-semibold">
                {intl.formatMessage({ id: "branches" })}{" "}
              </span>
              <span className="text-sm font-semibold ">
                {locations?.data?.map((e: any) => (
                  <span>{e?.name}</span>
                ))}
              </span>
            </div>
          </div>
          <Divider className="my-4" />
          <div className="flex flex-col items-center w-full mb-1">
            <SwitchItem
              options={options}
              title={intl.formatMessage({ id: "sendAlertsBeforeBooking" })}
              name1="alerts_before_booking_time"
              name2="enable_alerts_before_booking"
            />
            <SwitchItem
              options={options}
              title={intl.formatMessage({ id: "sendAlertsSameDay" })}
              name1="alerts_before_booking_same_day_time"
              name2="enable_alerts_before_booking_same_day"
            />
            {/* <SwitchItem
              options={options}
              title={intl.formatMessage({ id: "sendAlertsByEmail" })}
              name2="enable_notices_via_email"
            />
            <SwitchItem
              options={options}
              title={intl.formatMessage({ id: "sendAlertsSameDay" })}
              name2="enable_notices_via_phone"
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralAlerts;
